import React from 'react'
import {
    Container,
    Row, Col, Label,
} from 'reactstrap'
import {
    getLatest,
} from '../model/request/machine'
import dateFormat from 'dateformat'

function expected_end_time(machine) {
  if (machine.end_time) {
    return machine.end_time;
  } else {
    // return machine.start_time + (machine.expected_time * 1.0740825 + 264.34014179)
    return machine.start_time + machine.expected_time
  }
}

class MachineDockViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
          'machines': [],
          'latest_index': 0,
        }
    }

    componentDidMount() {
        this.props.turnOnLoader()

        getLatest(this.props.id).then(
            (result) => {
                result.sort(function(a, b) {
                  if ((!!a.end_time) !== (!!b.end_time)) {
                    return (!!b.end_time) - (!!a.end_time);
                  }
                  return expected_end_time(a) - expected_end_time(b)
                });

                let latest_index = 0;
                for (let i = 0; i < result.length; i++) {
                  if (
                    result[i].start_time >
                    result[latest_index].start_time
                  ) {
                    latest_index = i;
                  }
                }
                
                this.setState({
                    'machines': result,
                    'latest_index': latest_index,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    secondsToDate(seconds) {
      let d = new Date(0);
      d.setUTCSeconds(seconds);
      return d;
    }

    formatSeconds(seconds) {
      const date = this.secondsToDate(seconds)
      if (!isNaN(date)) {
        return dateFormat(date, 'mmmm d, yyyy hh::MM tt')
      }
      return ""
    }

    makeRows() {
        return this.state.machines.map((machine, index) => {
            return <Col key={"card"+index} lg="3" sm="6">
              <Container>
                <Row><Col><Label
                  style={{
                    'fontSize': '18pt',
                    'fontWeight': '400',
                  }}
                >{machine.machine}</Label></Col></Row>
                {machine.end_time ? "Machine Stopped" : "Is Running"}
                {this.labelAndValue('File', machine.file_name)}
                {this.labelAndValue('Start Time', this.formatSeconds(machine.start_time))}
                {this.labelAndValue('End Time', (machine.expected_time || machine.end_time) ? this.formatSeconds(expected_end_time(machine)) : '')}
              </Container>
            </Col>
        })
    }

    hasMachines() {
      return this.state.latest_index < this.state.machines.length
    }

    latestMachine() {
      return this.state.machines[this.state.latest_index]
    }

    labelAndValue(label, value) {
      return <Col><Container>
        <Row><Col><Label>{label}</Label></Col></Row>
        <Row><Col><Label>{value}</Label></Col></Row>
      </Container></Col>
    }

    render() {
        return (
            <Container>
              <Row><Col><Label
                style={{
                  'fontSize': '20pt',
                  'fontWeight': '400',
                }}
              >Room</Label></Col></Row>
              <Row>
                {this.hasMachines() ? <>
                  {this.labelAndValue(
                    'Temperature',
                    this.latestMachine().temperature
                  )}
                  {this.labelAndValue(
                    'Humidty',
                    this.latestMachine().humidity
                  )}
                  {this.labelAndValue(
                    'Air Quality',
                    this.latestMachine().air_quality
                  )}
                  {this.labelAndValue(
                    'Pressure',
                    this.latestMachine().pressure
                  )}
                  </>
                  :<></>
                }
              </Row>
              <Row><Col><Label
                style={{
                  'fontSize': '20pt',
                  'fontWeight': '400',
                }}
              >Machines</Label></Col></Row>
              <Row>
                {this.makeRows()}
              </Row>
              
            </Container>
        )
    }
}

export default MachineDockViewController

